import { Controller, useFormContext } from 'react-hook-form';

import { CheckboxField } from '@nesso/ui/primitives/checkbox-field';
import { SelectField } from '@nesso/ui/primitives/select-field';

import { type AddClientContactInput, CONTACT_RELATIONSHIP_OPTIONS } from '@/entities/client';

export function AddClientContactFormRelationship() {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<AddClientContactInput>();

    return (
        <>
            <Controller
                control={control}
                name="relationship"
                render={({ field, fieldState }) => (
                    <SelectField
                        {...field}
                        id={field.name}
                        label="Relationship to client"
                        value={field.value ?? ''}
                        options={CONTACT_RELATIONSHIP_OPTIONS}
                        disabled={isSubmitting}
                        error={fieldState.error?.message ?? fieldState.invalid}
                        fieldClassName="max-w-84"
                    />
                )}
            />
            <div className="flex flex-col gap-3">
                <Controller
                    control={control}
                    name="isEmergencyContact"
                    render={({ field }) => (
                        <CheckboxField
                            id={field.name}
                            name={field.name}
                            label="Emergency contact"
                            checked={field.value}
                            onCheckedChange={(checked) => field.onChange(checked === true)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            disabled={isSubmitting}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="isBillingContact"
                    render={({ field }) => (
                        <CheckboxField
                            id={field.name}
                            name={field.name}
                            label="Billing contact"
                            checked={field.value}
                            onCheckedChange={(checked) => field.onChange(checked === true)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            disabled={isSubmitting}
                        />
                    )}
                />
            </div>
        </>
    );
}
